import React from 'react';
import { Button, Form, Table, Upload, message, Tag } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import localStorage from '../../../../utils/localStorage';
import './style.css';
import { StyledSubHeading } from '../style';

class ValidConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mockAsset: [],
      mockDevice: [],
      mockParameter: []
    };
  }

  render() {
    let { mockAsset, mockDevice, mockParameter } = this.state;
    let assetColumns = [
      {
        title: 'AssetCode',
        dataIndex: 'AssetCode',
        key: 'AssetCode'
      },
      {
        title: 'unmatchedcolumn',
        key: 'unmatchedcolumn',
        dataIndex: 'unmatchedcolumn',
        render: (_, { unmatchedcolumn }) => (
          <>
            {unmatchedcolumn.map((tag) => {
              let color = tag.length > 0 ? 'geekblue' : 'green';
              return (
                <Tag color={color} key={tag}>
                  {tag.toUpperCase()}
                </Tag>
              );
            })}
          </>
        )
      },
      {
        title: 'Type',
        dataIndex: 'Type',
        key: 'Type'
      }
    ];
    let columns = [
      {
        title: 'DeviceCode',
        dataIndex: 'DeviceCode',
        key: 'DeviceCode'
      },
      {
        title: 'unmatchedcolumn',
        key: 'unmatchedcolumn',
        dataIndex: 'unmatchedcolumn',
        render: (_, { unmatchedcolumn }) => (
          <>
            {unmatchedcolumn.map((tag) => {
              let color = tag.length > 14 ? 'geekblue' : 'green';
              if (tag === 'EquipmentType') {
                color = 'volcano';
              }
              return (
                <Tag color={color} key={tag}>
                  {tag.toUpperCase()}
                </Tag>
              );
            })}
          </>
        )
      },
      {
        title: 'Type',
        dataIndex: 'Type',
        key: 'Type'
      }
    ];
    let parameterColumns = [
      {
        title: 'DeviceCode',
        dataIndex: 'DeviceCode',
        key: 'DeviceCode'
      },
      {
        title: 'ParameterCode',
        dataIndex: 'ParameterCode',
        key: 'ParameterCode'
      },
      {
        title: 'unmatchedcolumn',
        key: 'unmatchedcolumn',
        dataIndex: 'unmatchedcolumn',
        render: (_, { unmatchedcolumn }) => (
          <>
            {unmatchedcolumn.map((tag) => {
              let color = tag.length > 15 ? 'geekblue' : 'green';
              if (tag === 'EdgeCode') {
                color = 'volcano';
              }
              return (
                <Tag color={color} key={tag}>
                  {tag.toUpperCase()}
                </Tag>
              );
            })}
          </>
        )
      },
      {
        title: 'Type',
        dataIndex: 'Type',
        key: 'Type'
      }
    ];

    let siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;

    const assetprops = {
      name: 'file',
      action: `/api/asset/checkDuplicatesAssets?SiteId=${siteId}`,
      accept: 'text/csv',
      multiple: 'false',
      headers: {
        Authorization: Authorization
      },
      onChange: (info) => {
        if (info.file.status === 'done') {
          message.success('File Validated Successfully');
          mockAsset = info.file.response;
          this.setState({
            verifyAssetStatus: true,
            validatedFile: info.file.name,
            mockAsset
          });
        } else if (info.file.status === 'error') {
          message.error('Validation Failed');
        }
      }
    };

    const props = {
      name: 'file',
      action: `/api/device/checkDuplicatesDevices?SiteId=${siteId}`,
      accept: 'text/csv',
      headers: {
        Authorization: Authorization
      },
      onChange: (info) => {
        if (info.file.response) {
          message.success('File Validated Successfully');
          mockDevice = info.file.response;
          this.setState({ verifyStatus: true, validatedFile: info.file.name, mockDevice });
        } else if (info.file.status === 'error') {
          message.error('Validation Failed');
        }
      }
    };

    const parameterProps = {
      name: 'file',
      action: `/api/parameter/checkDuplicatesParameters?SiteId=${siteId}`,
      accept: 'text/csv',
      headers: {
        Authorization: Authorization
      },
      onChange: (info) => {
        if (info.file.status === 'done') {
          message.success('File Validated Successfully');
          mockParameter = info.file.response;
          this.setState({
            verifyParameterstatus: true,
            validatedFile: info.file.name,
            mockParameter
          });
        } else if (info.file.status === 'error') {
          message.error('Validation Failed');
        }
      }
    };

    return (
      <Form>
        <div style={{ marginBottom: '15px' }}>
          <StyledSubHeading style={{ position: 'relative', right: 505 }}>
            Asset Validation
          </StyledSubHeading>
          <Form.Item label="Asset Configuration">
            <Upload {...assetprops}>
              <Button icon={<UploadOutlined />}>Upload a file</Button>
            </Upload>
          </Form.Item>
          <Table className="table" columns={assetColumns} dataSource={mockAsset} />
        </div>
        {/* <Divider style={{border: '1px dashed'}} /> */}
        <div style={{ marginBottom: '15px' }}>
          <StyledSubHeading style={{ position: 'relative', right: 505 }}>
            Device Validation
          </StyledSubHeading>
          <Form.Item label="Device Configuration">
            <Upload {...props}>
              <Button icon={<UploadOutlined />}>Upload a file</Button>
            </Upload>
          </Form.Item>
          <Table className="table" columns={columns} dataSource={mockDevice} />
          {/* <Divider style={{border: '1px dashed'}} /> */}
        </div>
        <div style={{ marginBottom: '15px' }}>
          <StyledSubHeading style={{ position: 'relative', right: 505 }}>
            Parameter Validation
          </StyledSubHeading>
          <Form.Item label="Parameter Configuration">
            <Upload {...parameterProps}>
              <Button icon={<UploadOutlined />}>Upload a file</Button>
            </Upload>
          </Form.Item>
          <Table className="table" columns={parameterColumns} dataSource={mockParameter} />
        </div>
      </Form>
    );
  }
}

export default ValidConfiguration;
